/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ReportUrl } from '../../models/report-url';
import { ReportUrlDto } from '../../models/report-url-dto';

export interface UpdateReportUrl$Params {
  reportUrlId: string;
  body: ReportUrlDto;
}

export function updateReportUrl(
  http: HttpClient,
  rootUrl: string,
  params: UpdateReportUrl$Params,
  context?: HttpContext
): Observable<StrictHttpResponse<ReportUrl>> {
  const rb = new RequestBuilder(rootUrl, updateReportUrl.PATH, 'put');
  if (params) {
    rb.path('reportUrlId', params.reportUrlId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ReportUrl>;
    })
  );
}

updateReportUrl.PATH = '/admin/reporting/report-url/{reportUrlId}';
